"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPOGRAPHY_FONTS = ['header', 'body'];
exports.defaultFonts = {
    header: 'Roboto Mono, monospace',
    body: 'Open Sans, sans-serif',
};
exports.TYPOGRAPHY_WEIGHTS = [
    'bold',
    'semiBold',
    'medium',
    'regular',
    'light',
];
exports.defaultFontWeights = {
    bold: 700,
    semiBold: 600,
    medium: 500,
    regular: 400,
    light: 300,
};
exports.TYPOGRAPHY_VARIANTS = [
    'headline',
    'subheading',
    'title',
    'subtitle',
    'body',
    'caption',
    'label',
];
exports.defaultTypography = {
    fonts: exports.defaultFonts,
    weights: exports.defaultFontWeights,
    headline: {
        fontFamily: exports.defaultFonts.header,
        fontSize: 28,
        fontWeight: exports.defaultFontWeights.bold,
        textTransform: undefined,
    },
    subheading: {
        fontFamily: exports.defaultFonts.header,
        fontSize: 24,
        fontWeight: exports.defaultFontWeights.regular,
        textTransform: undefined,
    },
    title: {
        fontFamily: exports.defaultFonts.header,
        fontSize: 20,
        fontWeight: exports.defaultFontWeights.bold,
        textTransform: undefined,
    },
    subtitle: {
        fontFamily: exports.defaultFonts.body,
        fontSize: 18,
        fontWeight: exports.defaultFontWeights.semiBold,
        textTransform: undefined,
    },
    body: {
        fontFamily: exports.defaultFonts.body,
        fontSize: 15,
        fontWeight: exports.defaultFontWeights.regular,
        textTransform: undefined,
    },
    caption: {
        fontFamily: exports.defaultFonts.body,
        fontSize: 11,
        fontWeight: exports.defaultFontWeights.regular,
        textTransform: undefined,
    },
    label: {
        fontFamily: exports.defaultFonts.body,
        fontSize: '.75rem',
        fontWeight: exports.defaultFontWeights.semiBold,
        textTransform: 'uppercase',
    },
};
